// Browser page translation (Chrome and the Google app on iOS, Google Translate)
// replaces the text nodes React rendered with its own. When React later removes
// one of those nodes, or inserts next to it, the node is no longer a child of the
// parent React expects, so the DOM throws NotFoundError and the page falls into
// the error boundary (Error Tracking issue 26cf91d6: iOS users in non-English
// countries). Skipping only those impossible operations keeps the page working;
// every other call goes through unchanged.
// Workaround from https://github.com/facebook/react/issues/11538
export function installTranslationDomGuard() {
  if (typeof Node !== "function" || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function(child) {
    if (child.parentNode !== this) return child;
    return originalRemoveChild.call(this, child);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) return newNode;
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
}
